import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { map, times, isEmpty } from 'lodash';
import { compose } from 'recompose';

import { HHInput, HHSingleSelect } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    title: Yup
      .string().min(1, translate('form.error.string.min'))
      .max(60, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    maximum: Yup
      .number()
      .min(1, translate('form.error.string.min'))
      .required(translate('form.error.mixed.required'))
  }),
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.CMS_JUDGING_CRITERIA_FORM_CREATE
});

const JudgingCriteriaForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isEditing,
    handleCancel,
    translate, errors
  } = props;

  return (
    <Form
      className='cms-judgingCriteria_form cms-judgingCriteria_table_item_description'
      onSubmit={handleSubmit}
    >
      <div className='cms-judgingCriteria_form_formGroup'>
        <Form.Field>
          <label htmlFor='title'>{translate('title.required')}</label>
          <Field
            name='title'
            component={HHInput}
            otherProps={{
              type: 'text',
              id: 'title',
              maxLength: 64
            }}
          />
        </Form.Field>
      </div>

      <Form.Field className='cms-judgingCriteria_form_limit'>
        <label htmlFor='maximum'>{translate('maximumScore')} *</label>
        <Field
          name='maximum'
          component={HHSingleSelect}
          otherProps={{
            id: 'maximum',
            simpleValue: true,
            searchable: false,
            clearable: false,
            options: map(times(100, x => x + 1), y => ({
              value: y,
              label: y
            })),
            placeholder: 'maximum score...'
          }}
        />
      </Form.Field>

      <div className='cms-judgingCriteria_form_btnGroup'>
        {handleCancel && (
          <Button
            basic
            type='button'
            onClick={handleCancel}
            className='cms-judgingCriteria_form_btnGroup_btn-cancel'
          >
            {translate('cancel')}
          </Button>
        )}
        <Button
          primary
          disabled={isSubmitting || !isEmpty(errors)}
          loading={isSubmitting}
          className='cms-judgingCriteria_form_btnGroup_btn-submit'
          type='submit'
        >
          {isEditing ? translate('save') : translate('add')}
        </Button>
      </div>
    </Form>
  );
};

export default compose(
  withLocalize,
  formikEnhancer
)(JudgingCriteriaForm);




// WEBPACK FOOTER //
// ./src/components/forms/judgingCriteriaForm.js